import { useGetMyAccess } from '../services/redux/api/usersApi';
import { LoginUserStatus, useAuth } from '../context/AuthContext';

export function useAccess() {
  const { loginUserStatus } = useAuth();
  const isLoggedIn = loginUserStatus === LoginUserStatus.loggedIn;
  const { data: access } = useGetMyAccess(undefined, { skip: !isLoggedIn });

  return { loading: isLoggedIn && !access, access };
}
